import { Modal } from 'bootstrap';
import Masonry from 'masonry-layout';

window.addEventListener("load", function () {
  let activeElement;
  const gallery_tile = document.querySelector("div.gallery-tile");
  if (!gallery_tile){
    return;
  }
  if (document.body.classList.contains("template-edit")) {
    // Only enable when not in edit mode
    return;
  }
  // Event delegation on .gallery-tile
  gallery_tile.addEventListener("click", function (e) {
      const thumbnail = e.target.closest(".thumbnail");
      if (!thumbnail) return;

      e.preventDefault();
      activeElement = document.activeElement;

      const modal = document.getElementById("gallery-tile-modal");

      if (!modal.classList.contains("modal")) {
        modal.classList.add("modal");
      }

      const modalBody = modal.querySelector(".modal-body");
      modalBody.innerHTML = "";
      const parentDiv = thumbnail.closest("div").cloneNode(true);
      modalBody.appendChild(parentDiv);

      const modalTitle = modal.querySelector(".modal-title");
      const modalLink = modal.querySelector("a.gallery-image-link");
      const modalImage = modal.querySelector("a.gallery-image-link img");
      
      // Update modal title and image
      const img = thumbnail.querySelector("img");
      modalTitle.textContent = img.getAttribute("alt");

      if (modalLink && modalImage) {
          if (img.dataset.galleryLink !== undefined){
            modalLink.href = img.dataset.galleryLink;
            modalLink.style.pointerEvents = "auto";
            modalLink.style.cursor = "pointer";
          } else {
            modalLink.removeAttribute("href");
            modalLink.style.pointerEvents = "none";
            modalLink.style.cursor = "default";
          }
          modalImage.src = img.dataset.modalSrc;
      }

      const modalDialog = modal.querySelector(".modal-dialog");

      modal.addEventListener("shown.bs.modal", function () {
          if (modalImage.complete) {
              updateModalSize();
          } else {
              modalImage.onload = updateModalSize;
          }
      });

      function updateModalSize() {
          const imgWidth = modalImage.naturalWidth;
          const maxWidth = window.innerWidth * 0.9; // Ensure it doesn't exceed viewport width

          modalDialog.style.maxWidth = Math.min(imgWidth, maxWidth) + "px";
      }
      // Show the modal
      const modalInstance = new Modal(modal);
      modalInstance.show();
  });

  document.getElementById("gallery-tile-modal").addEventListener("hidden.bs.modal", function () {
      if (activeElement) activeElement.focus();
  });

  const grid = document.querySelector("div.gallery-tile div.masonry-grid");
  if (grid) {
      new Masonry(grid, {
          itemSelector: ".masonry-item",
          percentPosition: true,
          columnWidth: 50
      });

      // Uncomment if using imagesLoaded for better layout adjustment
      // imagesLoaded(grid).on("progress", function () {
      //     msnry.layout();
      // });
  }

});